import { useEffect, useRef, useState } from "react";

export const ClampedText = ({ text, className = "", user }) => {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const ref = useRef(null);
const renderTextWithLinks = (text) => {
  if (!text) return text;

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.split(urlRegex).map((part, i) =>
    urlRegex.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline break-all"
      >
        {part}
      </a>
    ) : (
      part
    )
  );
};

const linkColorClass =
  user === 1
    ? "text-[#1D2951] underline underline-offset-2"
    : "text-[#1D2951] underline  underline-offset-2";


  useEffect(() => {
    if (!ref.current) return;
    const id = requestAnimationFrame(() => {
      const el = ref.current;
      if (!el) return;
      setIsClamped(el.scrollHeight > el.clientHeight + 1);
    });
    return () => cancelAnimationFrame(id);
  }, [text, expanded]);

  return (
    <div className={className}>
      <div
        ref={ref}
        className="whitespace-pre-wrap break-words"
        style={
          expanded
            ? {}
            : {
                display: "-webkit-box",
                WebkitLineClamp: 2, // <- 2 full lines + partial 3rd with …
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
        }
      >
      {renderTextWithLinks(text)}

      </div>

      {isClamped && !expanded && (
        <button
          type="button"
          className={`mt-1 text-sm font-font1  focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none ${linkColorClass}`}
          onClick={() => setExpanded(true)}
        >
          Read more
        </button>
      )}

      {expanded && (
        <button
          type="button"
          className={`mt-1 text-sm font-font1 focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none ${linkColorClass}`}
          onClick={() => setExpanded(false)}
        >
          Show less
        </button>
      )}
    </div>
  );
};
